import type { FC } from 'react'
import classNames from 'classnames'

import type { TSkeletonProps } from './types'
import styles from './Skeleton.module.scss'

const Skeleton: FC<TSkeletonProps> = ({ className, width, height }) => (
  <div
    className={classNames(styles.wrapper, className)}
    style={{ width, height }}
    aria-busy="true"
    aria-label="loading content"
  />
)

export default Skeleton
